const moment = require("moment");

export default {
  props: {
    image: {
      type: String,
      required: true
    },
    alt_image: {
      type: String,
    },
    date: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    fromStorage: {
      type: Boolean,
      required: false,
      default: () => true
    },
    blogIndexPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedDate() {
      if(this.date){
        return moment(new Date(this.date)).format("DD-MM-YYYY");
      }
    },
    formattedSrc() {
      if(!this.image) return '';
      return this.fromStorage ? `/storage/${this.image}` : this.image;
    }
  },
  methods: {
    readPost() {
      window.location.href = this.link;
    }
  }
};
